import type { UserRole } from "@/types";

/**
 * Panelga kirish huquqi bor rollar.
 *
 * O'qituvchi ham, o'quvchi ham bu yerga KIRMAYDI: ularning ekranlari
 * ommaviy SPA da. Login muvaffaqiyatli bo'lsa ham, roli shu ro'yxatda
 * bo'lmagan odamning sessiyasi darhol yopiladi (`auth-guard.tsx`).
 */
export const STAFF_ROLES = ["admin", "moderator"] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export const isStaffRole = (role: UserRole | undefined | null): role is StaffRole =>
  !!role && (STAFF_ROLES as readonly string[]).includes(role);

/** Faqat adminga ochiq bo'lgan bo'lim/amal ekanini bildiradi. */
export const isAdmin = (role: UserRole | undefined | null): boolean => role === "admin";
